import { render, staticRenderFns } from "./MenuMargins.vue?vue&type=template&id=db24718c&scoped=true&"
import script from "./MenuMargins.vue?vue&type=script&lang=js&"
export * from "./MenuMargins.vue?vue&type=script&lang=js&"
import style0 from "./MenuMargins.vue?vue&type=style&index=0&id=db24718c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db24718c",
  null
  
)

export default component.exports